import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";
import ImageButton from "slides/components/ImageButton.react";

export default class Brancher extends React.Component {
    handleClick = (index) => {
        // this.props.trackInteraction(index);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let mappedOptions = _.map(
            this.props.data.popupitems,
            (option, index) => {
                return (
                    <ImageButton
                        {...this.props}
                        fluid
                        index={index}
                        key={"button-" + index}
                        image={option.image}
                        name={option.option}
                        link={option.caption}
                        handleClick={this.handleClick}
                    />
                );
            }
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose an option:"}
                    mainContent={mappedOptions}
                />
            </div>
        );
    }
}
